import * as React from "react";
import type { SVGProps } from "react";
const SvgDataMetering = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      fill="#23F6E7"
      d="M23 9.366v3.512c0 2.91-4.702 5.268-10.5 5.268S2 15.787 2 12.878V9.366c0 2.91 4.702 5.268 10.5 5.268S23 12.275 23 9.366M2 15.22c0 2.909 4.702 5.268 10.5 5.268S23 18.128 23 15.22v3.512C23 21.64 18.298 24 12.5 24S2 21.641 2 18.732zm10.5-2.927C6.702 12.293 2 9.933 2 7.024s4.702-5.268 10.5-5.268S23 4.116 23 7.024c0 2.91-4.702 5.269-10.5 5.269"
    />
    <path
      fill="#90B9FF"
      d="M23 7.61v3.512c0 2.91-4.702 5.268-10.5 5.268S2 14.031 2 11.122V7.61c0 2.909 4.702 5.268 10.5 5.268S23 10.519 23 7.61M2 13.463c0 2.91 4.702 5.269 10.5 5.269S23 16.372 23 13.463v3.513c0 2.909-4.702 5.268-10.5 5.268S2 19.884 2 16.976zm10.5-2.926C6.702 10.537 2 8.177 2 5.268S6.702 0 12.5 0 23 2.359 23 5.268c0 2.91-4.702 5.269-10.5 5.269"
      opacity={0.6}
    />
  </svg>
);
export default SvgDataMetering;
